import { Flex, Image, Text, Box } from '@chakra-ui/react'
import Programming from '../../assets/progamming.svg'
import { ButtonPrimary } from '../ButtonPrimary'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useEffect } from 'react';
import { Link } from "react-scroll"


export const Introduce = () =>{

    useEffect(()=>{
        gsap.registerPlugin(ScrollTrigger)

        gsap.from(".left", {
            x: -700,
            opacity: 0,
          });
          gsap.to(".left", {
            x: 0,
            opacity: 1,
            duration: 3,
            scrollTrigger: {
              trigger: ".left",
              toggleActions: "restart play",
            },
          });


        gsap.from(".right", {
            x: 700,
            opacity: 0,
        });
        gsap.to(".right", {
            x: 0,
            opacity: 1,
            duration: 3,
            scrollTrigger: {
            trigger: ".right",
            toggleActions: "restart play",
            },
        });
    },[])

    return(
        <Flex 
            h={["80%","80%", "100vh","100vh" ]}
            bg="blue.500"
            overflowX="hidden"
            padding={["20px","20px","50px","50px"]}
            mt={["70px", "70px", "0px", "0px"]}
        >
            <Box 
                w={["100%", "100%", "50%","50%"]}
                display="flex"
                justifyContent="center"
                flexDir="column"
                mb="200px"
                className='left'
            >
                <Text
                    fontSize="4xl"
                    fontWeight="bold"
                >Olá, me chamo <Text as="span" color="pink.500">Gustavo</Text>,<br/>sou um  desenvolvedor <Text as="span" color="pink.500">Full-Stack</Text></Text>
                <Text color="gray.300" mb="2">Dê uma olhada nos meus projetos!</Text>
                <ButtonPrimary >
                    <Link 
                        width="100%"
                        height="100%"
                        textDecoration="none"
                        to="projects"
                        smooth={ true }
                        duration={ 1000 }
                    >
                        Projetos
                    </Link>
                </ButtonPrimary>
            </Box>
            <Image 
                display={["none", "none", "block", "block"]}
                className='right'
                src={Programming}
                w="40%"
            />
        </Flex>
    )
}